import React, { useState } from 'react'
import { Typography } from '@material-ui/core'
import { Box, Checkbox, Tooltip } from '@mui/material'
import { Resource } from 'Generated/academy-graphql-types'
import {
  CheckboxAndLabel,
  Copy,
  InfoIcon,
  OptionalInputContainer,
  Row,
} from './TaskModalV2.styled'
import { AcademyResourceSearch } from '../ResourceTasks/AcademyResourceSearch'
import { OnUpdateOptions } from '../types'

type AcademyResourceOptionsProps = {
  onUpdateOptions: OnUpdateOptions
  resource: Resource | null | undefined
}

export const AcademyResourceOptions = ({
  onUpdateOptions,
  resource,
}: AcademyResourceOptionsProps) => {
  const [isAddingResource, setIsAddingResource] = useState(!!resource)

  const handleResourceToggle = () => {
    if (isAddingResource) onUpdateOptions({ key: 'resource', value: null })
    setIsAddingResource(!isAddingResource)
  }

  return (
    <>
      <Row>
        <CheckboxAndLabel>
          <Checkbox
            checked={isAddingResource}
            onChange={handleResourceToggle}
          />
          <Copy>Include an Academy Resource</Copy>
        </CheckboxAndLabel>
        <Tooltip
          title={
            <Box sx={{ p: 2, maxWidth: 300 }}>
              <Typography>
                Use our academy resources, like templates, to support your goal
                progress and task completion. You can also create learning tasks
                to remind you to review academy resources later. Example: Create
                a task to &quot;Increase fundraising foundations knowledge&quot;
                and link it to our &quot;Fundraising FAQs&quot; article.
              </Typography>
            </Box>
          }
          arrow
          placement='right'
        >
          <InfoIcon />
        </Tooltip>
      </Row>
      {isAddingResource && (
        <OptionalInputContainer>
          <AcademyResourceSearch
            label='Search for Academy Resource'
            placeholder='Type, or copy and paste, the name of the resource'
            onSelectResource={(r) =>
              onUpdateOptions({ key: 'resource', value: r })
            }
            resource={resource}
          />
        </OptionalInputContainer>
      )}
    </>
  )
}
